module.exports = __webpack_public_path__ + "img/liuyanping.ba8f93f1.png";